/**
 * Copyright (c) 2023 Google LLC
 * SPDX-License-Identifier: MIT
 */

import type { Shadows } from '../system'

/**
 * @deprecated - Use `elevations` instead
 */
export const shadows: Shadows = {
  1: '0px 1px 8px rgba(0, 0, 0, 0.08), 0px 1px 1px rgba(0, 0, 0, 0.05)',
  2: '0 2px 12px rgba(0, 0, 0, 0.11), 0 1px 4px rgba(0, 0, 0, 0.04)',
  3: '0 3px 18px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.04)',
  4: '0 4px 20px rgba(0, 0, 0, 0.14), 0 1px 4px rgba(0, 0, 0, 0.04),  0 10px 8px 4px rgba(0, 0, 0, 0.01)',
  5: '0 2px 30px rgba(0, 0, 0,.16), 0 1px 4px rgba(0, 0, 0, 0.04),  0 14px 10px 8px rgba(0, 0, 0, 0.02)',
  6: '0 5px 42px 0px rgba(0, 0, 0,.18),  0 1px 4px rgba(0, 0, 0, 0.05), 0 16px 20px 10px rgba(0, 0, 0, 0.025)',
}
